// import twFocusClass from "utils/twFocusClass";

// const Pagination = ({ pagination, fetchData }: any) => {

//   const renderItem = () => {
//     const items = [];
//     for (let index = 0; index < pagination.last_page; index++) {
//       if (index + 1 === pagination.current_page) {
//         // RETURN ACTIVE PAGINATION
//         items.push(
//           <span
//             key={index}
//             className={`inline-flex w-11 h-11 items-center justify-center rounded-full bg-primary-700 text-white ${twFocusClass()}`}
//           >
//             {index + 1}
//           </span>
//         );
//       } else {
//         // RETURN UNACTIVE PAGINATION
//         items.push(
//           <span
//             key={index}
//             onClick={() => fetchData(index + 1)}
//             className={`click inline-flex w-11 h-11 items-center justify-center rounded-full bg-white hover:bg-neutral-100 border border-neutral-200 text-neutral-6000 dark:text-neutral-400 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:border-neutral-700 ${twFocusClass()}`}
//           >
//             {index + 1}
//           </span>
//         );
//       }
//     }
//     return items;
//   };

//   return (
//     <nav
//       className={`nc-Pagination inline-flex space-x-1 text-base font-medium`}
//     >
//       {renderItem()}
//     </nav>
//   );
// };

// export default Pagination;


interface PaginationProps {
  pagination: {
    current_page: number
    last_page: number
    per_page?: number
    total?: number
  }
  fetchData: any
}

const Pagination = ({ pagination, fetchData }: PaginationProps) => {
  // If there's only 1 page, don't show pagination
  if (pagination.last_page <= 1) {
    return null
  }

  const { current_page, last_page } = pagination

  // Function to determine which page numbers to show
  const getPageNumbers = (): (number | string)[] => {
    const delta = 2 // Number of pages to show before and after current page
    const range: (number | string)[] = []

    // Always add first page
    range.push(1)

    // Calculate start and end of the visible range
    const rangeStart = Math.max(2, current_page - delta)
    const rangeEnd = Math.min(last_page - 1, current_page + delta)

    // Add ellipsis after first page if needed
    if (rangeStart > 2) {
      range.push("...")
    }

    // Add pages in the middle range
    for (let i = rangeStart; i <= rangeEnd; i++) {
      range.push(i)
    }

    // Add ellipsis before last page if needed
    if (rangeEnd < last_page - 1) {
      range.push("...")
    }

    // Always add last page if it's not the first page
    if (last_page > 1) {
      range.push(last_page)
    }

    return range
  }

  const pageNumbers = getPageNumbers()

  // Helper function for focus styling
  const twFocusClass = (): string => {
    return "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:focus:ring-offset-neutral-900"
  }

  return (
    <nav className="flex items-center justify-center space-x-1 text-base font-medium">
      {/* Previous button */}
      <button
        onClick={() => current_page > 1 && fetchData(current_page - 1)}
        disabled={current_page <= 1}
        className={`inline-flex h-11 w-11 items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-600 transition-colors 
          ${current_page > 1 ? "hover:bg-neutral-100 cursor-pointer" : "opacity-50 cursor-not-allowed"} 
          dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-400 dark:hover:bg-neutral-800 ${twFocusClass()}`}
        aria-label="Previous page"
      >
        {/* Left chevron icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-5 w-5"
        >
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>

      {/* Page numbers */}
      {pageNumbers.map((page, index) => {
        if (page === "...") {
          return (
            <span
              key={`ellipsis-${index}`}
              className="inline-flex h-11 w-11 items-center justify-center text-neutral-600 dark:text-neutral-400"
            >
              &hellip;
            </span>
          )
        }

        const pageNumber = page as number
        const isActive = pageNumber === current_page

        if (isActive) {
          return (
            <span
              key={pageNumber}
              className={`inline-flex h-11 w-11 items-center justify-center rounded-full bg-primary-700 text-white ${twFocusClass()}`}
              aria-current="page"
            >
              {pageNumber}
            </span>
          )
        }

        return (
          <button
            key={pageNumber}
            onClick={() => fetchData(pageNumber)}
            className={`inline-flex h-11 w-11 items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-600 transition-colors hover:bg-neutral-100 cursor-pointer
              dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-400 dark:hover:bg-neutral-800 ${twFocusClass()}`}
          >
            {pageNumber}
          </button>
        )
      })}

      {/* Next button */}
      <button
        onClick={() => current_page < last_page && fetchData(current_page + 1)}
        disabled={current_page >= last_page}
        className={`inline-flex h-11 w-11 items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-600 transition-colors 
          ${current_page < last_page ? "hover:bg-neutral-100 cursor-pointer" : "opacity-50 cursor-not-allowed"} 
          dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-400 dark:hover:bg-neutral-800 ${twFocusClass()}`}
        aria-label="Next page"
      >
        {/* Right chevron icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-5 w-5"
        >
          <path d="M9 18l6-6-6-6" />
        </svg>
      </button>
    </nav>
  )
}

export default Pagination


